import styled from 'styled-components';
import { useContext } from 'react';
import { SidebarStateContext } from '../../../providers/MainProviders';
import Logo from '../../../assets/images/logos/reputationplus.png';
import Icon from '../../../assets/images/logos/reputationplus_icon.png';

const HeaderContainer = styled.div`
  display: flex;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  align-items: center;
  justify-content: center;
  min-height: 64px;
  padding: ${(props) => props.theme.spacing(1)};
  background-color: ${(props) => props.theme.palette.background.paper};
  z-index: 1;
`;

const SidebarHeader = () => {
  const { expanded } = useContext(SidebarStateContext);

  return (
    <HeaderContainer>
      {expanded ? (
        <img
          src={Logo}
          width="85%"
          alt="Reputativ Logo"
        />
      ) : (
        <img
          src={Icon}
          width="60%"
          alt="Reputativ Logo Icon"
        />
      )}
    </HeaderContainer>
  );
};

export default SidebarHeader;
